import { call, put, takeLatest } from 'redux-saga/effects'
import { FetchRemoteConfig } from 'src/constants/actionTypes'
import { Endpoints } from 'src/constants/endpoints'
import type {
  FetchRemoteConfigPayload,
  RemoteConfigResponse,
  RemoteConfigValues,
} from 'src/interfaces/remoteConfig'
import { getApiErrorMessage } from 'src/utils/errorHandlers'
import { AsyncAction } from 'src/utils/reduxUtils'
import { captureSentryError } from 'src/utils/sentry'
import { ApiService, callClientSecureApi, callContractorPortalSecureApi } from './api/callApi'

function* onFetchRemoteConfig(action: AsyncAction<FetchRemoteConfigPayload, RemoteConfigValues>) {
  try {
    // Both tokens pass the endpoint's guard; each area sends the one it holds.
    const callSecureApi =
      action.payload.platform === 'contractorPortal'
        ? callContractorPortalSecureApi
        : callClientSecureApi

    const { payload }: { payload: RemoteConfigResponse } = yield call(
      callSecureApi,
      Endpoints.RemoteConfig,
      { apiService: ApiService.Paraworks },
    )

    const values = payload?.values ?? {}

    yield put(FetchRemoteConfig.success(values))

    if (action.next) {
      action.next(null, values)
    }
  } catch (err: any) {
    captureSentryError(err, { message: '[saga.remoteConfig.onFetchRemoteConfig] error' })

    yield put(FetchRemoteConfig.failed(err))

    if (action.next) {
      action.next(getApiErrorMessage(err, 'Failed to load remote config'))
    }
  }
}

export function* remoteConfigSaga() {
  yield takeLatest(FetchRemoteConfig.type.REQUEST, onFetchRemoteConfig)
}
